import React from "react";
import { Grid, Card, CardContent, Skeleton, Box } from "@mui/material";

export const DashboardSkeleton = () => {
  return (
    <Box sx={{ flexGrow: 1 }}>
      {/* Top Header Skeleton */}
      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 3 }}>
        <Box>
          <Skeleton variant="text" width={220} height={32} />
          <Skeleton variant="text" width={280} height={20} />
        </Box>
        <Skeleton variant="rectangular" width={180} height={40} sx={{ borderRadius: "8px" }} />
      </Box>

      {/* Row 1 Grid Skeleton */}
      <Grid container spacing={3} mb={3}>
        <Grid item xs={12} md={4}>
          <Card sx={{ height: 240, borderRadius: "14px" }}>
            <CardContent>
              <Skeleton variant="rectangular" height={180} sx={{ borderRadius: "10px" }} />
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={2}>
          <Card sx={{ height: 240, borderRadius: "14px" }}>
            <CardContent>
              <Skeleton variant="circular" width={48} height={48} sx={{ mb: 2 }} />
              <Skeleton variant="text" width="60%" height={24} />
              <Skeleton variant="text" width="80%" height={48} />
              <Skeleton variant="text" width="50%" height={20} />
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={2}>
          <Card sx={{ height: 240, borderRadius: "14px" }}>
            <CardContent>
              <Skeleton variant="circular" width={48} height={48} sx={{ mb: 2 }} />
              <Skeleton variant="text" width="60%" height={24} />
              <Skeleton variant="text" width="80%" height={48} />
              <Skeleton variant="text" width="50%" height={20} />
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={4}>
          <Card sx={{ height: 240, borderRadius: "14px" }}>
            <CardContent sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
              <Skeleton variant="text" width="60%" height={32} />
              <Skeleton variant="rectangular" height={48} sx={{ borderRadius: "10px" }} />
              <Skeleton variant="rectangular" height={48} sx={{ borderRadius: "10px" }} />
              <Skeleton variant="rectangular" height={40} sx={{ borderRadius: "8px" }} />
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* Row 2 Secondary KPI Skeleton */}
      <Grid container spacing={3} mb={3}>
        {[1, 2, 3, 4].map((item) => (
          <Grid item xs={12} sm={6} md={3} key={item}>
            <Card sx={{ height: 110, borderRadius: "14px" }}>
              <CardContent sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                <Skeleton variant="circular" width={44} height={44} />
                <Box sx={{ flexGrow: 1 }}>
                  <Skeleton variant="text" width="40%" height={36} />
                  <Skeleton variant="text" width="70%" height={20} />
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* Row 3 Charts Skeleton */}
      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <Card sx={{ height: 340, borderRadius: "14px" }}>
            <CardContent>
              <Skeleton variant="rectangular" height={280} sx={{ borderRadius: "10px" }} />
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={6}>
          <Card sx={{ height: 340, borderRadius: "14px" }}>
            <CardContent>
              <Skeleton variant="rectangular" height={280} sx={{ borderRadius: "10px" }} />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};
